import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import React, { useEffect, useRef, useState } from 'react'
import * as bie from "react-bootstrap";
import CommanFfcaDocumnets from './CommanFfcaDocumnets'
import CommanFfcaFacultyAvailability from './CommanFfcaFacultyAvailability'
import CommanLabAvailability from './CommanLabAvailability'
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import Swal from 'sweetalert2';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import * as Yup from 'yup';

export default function AfflRemarksOfFfca() {
    const hasFetchedData = useRef(false)

    const AfflRemarksFfcaValidation = Yup.object({
        remarks: Yup.string().required(ERROR_MSG).nullable(),
        data: Yup.array().of(Yup.object().shape({
            clsroomDeficiency: Yup.string().required(ERROR_MSG).nullable(),
            clsroomDeficiencyRemarks: Yup.string().when('clsroomDeficiency', {
                is: 'Deficiencies are there',
                then: Yup.string().required(ERROR_MSG).nullable(),
                otherwise: Yup.string().nullable(),
            }),

            labDeficiency: Yup.string().required(ERROR_MSG).nullable(),

            labDeficiencyRemarks: Yup.string().when('labDeficiency', {
                is: 'Deficiencies are there',
                then: Yup.string().required(ERROR_MSG).nullable(),
                otherwise: Yup.string().nullable(),
            }),

            facultyDeficiency: Yup.string().required(ERROR_MSG).nullable(),

            facultyDeficiencyRemarks: Yup.string().when('facultyDeficiency', {
                is: 'Deficiencies are there',
                then: Yup.string().required(ERROR_MSG).nullable(),
                otherwise: Yup.string().nullable(),
            }),
        }))
    });

    const AfflFacRemarksFormik = useFormik({
        initialValues: {
            data: [
                {
                    courseCategoryId: "",
                    courseId: "",
                    clsroomDeficiency: "",
                    clsroomDeficiencyRemarks: "",
                    labDeficiency: "",
                    labDeficiencyRemarks: "",
                    facultyDeficiency: "",
                    facultyDeficiencyRemarks: "",

                }
            ],
            remarks: ""

        },
        validationSchema: AfflRemarksFfcaValidation,
        onSubmit: (values) => {
            values.data.forEach(item => {
                item.remarks = AfflFacRemarksFormik?.values?.remarks
            });

            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveOamdcRemarksDetails`;
                    CommonAxiosPost(url, values?.data).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            GetOAMDCRemarksData();
                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });

        },
    })
    const [coursecatDta, setcoursecatDta] = useState([]);
    function GetCorseCatList() {
        let url = config.url.API_URL + `courseCategories`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setcoursecatDta(res?.data?.courseCategories);

            }
            else {
                setcoursecatDta([]);
            }
        })
    }

    const [getoamdccount, setoamdccount] = useState([]);
    function GetOamdcCount() {
        let url = config.url.API_URL + `getOamdcRemarksCount`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setoamdccount(res?.data?.OamdcRemarkscounts[0]);


            }
            else {
                setoamdccount([]);
            }
        })
    }
    const [oamdcremarksData, setoamdcremarksdata] = useState([])
    function GetOAMDCRemarksData() {
        let url = config?.url?.API_URL + "getOamdcRemarksDetails";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                setoamdcremarksdata(res?.data?.OamdcRemarksDetails)
                AfflFacRemarksFormik?.setFieldValue(`remarks`, res?.data?.OamdcRemarksDetails[0]?.remarks);

            }
            else {
                setoamdcremarksdata([])

            }

        })
    }

    useEffect(() => {
        if (!hasFetchedData.current) {
            GetCorseCatList();
            GetOAMDCRemarksData();
            GetOamdcCount();
            hasFetchedData.current = true
        }
    }, [])

    useEffect(() => {

        if (coursecatDta) {
            const afflRemarksffca = coursecatDta?.map(course => ({
                courseCategoryId: course?.course_cat_id,
                courseId: course?.course_id,
                clsroomDeficiency: course?.clsroom_deficiency,
                clsroomDeficiencyRemarks: course?.clsroom_deficiency_remarks,
                labDeficiency: course?.lab_deficiency,
                labDeficiencyRemarks: course?.lab_deficiency_remarks,
                facultyDeficiency: course?.faculty_deficiency,
                facultyDeficiencyRemarks: course?.facultyDeficiencyRemarks,
            }));
            AfflFacRemarksFormik.setValues({ ...AfflFacRemarksFormik?.values, data: afflRemarksffca });
        }
    }, [coursecatDta]);
    const isValid = getoamdccount?.flag_document_remarks === 1 && getoamdccount?.flag_lab_availability_remarks === 1 && getoamdccount?.flag_faculty_availability === 1;

    return (
        <>
            {getoamdccount?.flag_document_remarks == 1 ? (<>

                <div className="inner-herbpage-service-title-sub">
                    <h1 className="mb-0"> Documents Report</h1></div>
                <bie.Row className="px-2 pt-3 ">
                    <CommanFfcaDocumnets />
                </bie.Row>
            </>) : null}
            {getoamdccount?.flag_lab_availability_remarks == 1 ? (<>

                <div className="inner-herbpage-service-title-sub"><h1 className="mb-0">Lab Availability Report</h1></div>
                <bie.Row className="px-2 pt-3 m-0 ">
                    <CommanLabAvailability />
                </bie.Row>
            </>) : null}
            {getoamdccount?.flag_faculty_availability == 1 ? (<>
                <div className="inner-herbpage-service-title-sub">
                    <h1 className="mb-0"> Course - Faculty Availability Remarks</h1></div>
                <bie.Row className="px-2 pt-3 m-0">
                    <CommanFfcaFacultyAvailability />
                </bie.Row>
            </>) : null}




            <bie.Row className=" ">
                <FormikProvider value={AfflFacRemarksFormik}>
                    <Form onChange={AfflFacRemarksFormik.handleChange} onSubmit={AfflFacRemarksFormik.handleSubmit} className='affl-form'>
                        <div className="inner-herbpage-service-title-sub">
                            <h1 className="mb-0"> Remarks Of FFCA </h1></div>
                        {oamdcremarksData?.length == 0 ? (<>
                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th >Single Major Courses with Specialization</th>
                                            <th>Deficiencies in Class Rooms	</th>
                                            <th>Deficiencies (with Specific information)</th>
                                            <th> Deficiencies in Labs	</th>
                                            <th> Deficiencies (with Specific information)</th>
                                            <th> Deficiencies in Faculty	</th>
                                            <th> Deficiencies (with Specific information)</th>


                                        </tr>
                                    </thead>

                                    {coursecatDta && coursecatDta.map((course, index) => (
                                        <tbody key={index}>
                                            <tr>
                                                <td>{index + 1}</td>
                                                <td className='text-left'>
                                                    {course?.course_cat_name}

                                                </td>

                                                <td>
                                                    <Field
                                                        as="select"
                                                        className="form-control"
                                                        name={`data[${index}].clsroomDeficiency`}
                                                        onChange={e => {
                                                            AfflFacRemarksFormik?.setFieldValue(`data[${index}].clsroomDeficiencyRemarks`, '');
                                                        }}>
                                                        <option value="">---select---</option>
                                                        <option value="Deficiencies are there">Deficiencies are there</option>
                                                        <option value="Deficiencies Not there">Deficiencies Not there</option>
                                                    </Field>
                                                    <ErrorMessage name={`data[${index}].clsroomDeficiency`} component="div" className="text-error" />
                                                </td>

                                                <td>
                                                    {AfflFacRemarksFormik?.values?.data[index]?.clsroomDeficiency === "Deficiencies are there" && (
                                                        <>
                                                            <Field as="textarea" className="form-control" name={`data[${index}].clsroomDeficiencyRemarks`} maxLength="350" />
                                                            <ErrorMessage name={`data[${index}].clsroomDeficiencyRemarks`} component="div" className="text-error" />
                                                        </>
                                                    )}
                                                </td>

                                                <td>
                                                    <Field
                                                        as="select"
                                                        className="form-control"
                                                        name={`data[${index}].labDeficiency`}
                                                        onChange={e => {
                                                            AfflFacRemarksFormik?.setFieldValue(`data[${index}].labDeficiencyRemarks`, '');
                                                        }}
                                                    >
                                                        <option value="">---select---</option>
                                                        <option value="Deficiencies are there">Deficiencies are there</option>
                                                        <option value="Deficiencies Not there">Deficiencies Not there</option>
                                                    </Field>
                                                    <ErrorMessage name={`data[${index}].labDeficiency`} component="div" className="text-error" />
                                                </td>

                                                <td>
                                                    {AfflFacRemarksFormik?.values?.data[index]?.labDeficiency === "Deficiencies are there" && (
                                                        <>
                                                            <Field as="textarea" className="form-control" name={`data[${index}].labDeficiencyRemarks`} maxLength="350" />
                                                            <ErrorMessage name={`data[${index}].labDeficiencyRemarks`} component="div" className="text-error" />
                                                        </>
                                                    )}
                                                </td>

                                                <td>
                                                    <Field
                                                        as="select"
                                                        className="form-control"
                                                        name={`data[${index}].facultyDeficiency`}
                                                        onChange={e => {
                                                            AfflFacRemarksFormik?.setFieldValue(`data[${index}].facultyDeficiencyRemarks`, '');
                                                        }}
                                                    >
                                                        <option value="">---select---</option>
                                                        <option value="Deficiencies are there">Deficiencies are there</option>
                                                        <option value="Deficiencies Not there">Deficiencies Not there</option>
                                                    </Field>
                                                    <ErrorMessage name={`data[${index}].facultyDeficiency`} component="div" className="text-error" />
                                                </td>

                                                <td>
                                                    {AfflFacRemarksFormik?.values?.data[index]?.facultyDeficiency === "Deficiencies are there" && (
                                                        <>
                                                            <Field as="textarea" className="form-control" name={`data[${index}].facultyDeficiencyRemarks`} maxLength="350" />
                                                            <ErrorMessage name={`data[${index}].facultyDeficiencyRemarks`} component="div" className="text-error" />
                                                        </>
                                                    )}
                                                </td>
                                            </tr>
                                        </tbody>
                                    ))}


                                </table>
                            </div>

                            <bie.Row>
                                <bie.Col xs={12} sm={12} md={12} lg={1} xl={4} xxl={4} className='mb-2'>
                                    <label className='mb-1 field-mandatory' >Remarks:</label>
                                    <Field as="textarea" className="form-control" name="remarks" maxLength="300" />
                                    <ErrorMessage name="remarks" component="div" className="text-error" />
                                </bie.Col>
                            </bie.Row>
                            {isValid ? (<>
                                <div className="button-cend pt-1 mb-3">

                                    <button type="submit" className="btn btn-success mt-2 float-end mb-3">
                                        Submit
                                    </button>
                                </div>
                            </>) : <h5 style={{ color: "red", textAlign: "center" }} > Please Fill  Documents , Lab Availability & Faculty Availability</h5>}
                        </>) : null}

                        {oamdcremarksData?.length > 0 ? (<>
                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Single Major Courses with Specialization</th>
                                            <th>Deficiencies in Class Rooms	</th>
                                            <th>Deficiencies (with Specific information)</th>
                                            <th>  Deficiencies in Labs	</th>
                                            <th>  	Deficiencies (with Specific information)</th>
                                            <th>  Deficiencies in Faculty	</th>
                                            <th>  Deficiencies (with Specific information)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {oamdcremarksData !== undefined && oamdcremarksData !== null && oamdcremarksData !== '' && oamdcremarksData?.map((data, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td className='text-left'>{data?.course_cat_name}</td>
                                                <td>{data?.clsroom_deficiency}</td>
                                                <td>{data?.clsroom_deficiency_remarks}</td>
                                                <td>{data?.lab_deficiency}</td>
                                                <td>{data?.lab_deficiency_remarks}</td>
                                                <td>{data?.faculty_deficiency}</td>
                                                <td>{data?.faculty_deficiency_remarks}</td>
                                            </tr>))}
                                    </tbody>

                                </table>

                            </div>

                            <bie.Row>
                                <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className='mb-2'>
                                    <span ><b className='field-mandatory'>Remarks:</b></span>
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5} classname='mb-3'>

                                    <Field as="textarea" className="form-control" name="remarks" disabled />
                                    <ErrorMessage name="remarks" component="div" className="text-error" />
                                </bie.Col>
                            </bie.Row>
                        </>) : null}

                    </Form>
                </FormikProvider >

            </bie.Row >

        </>
    )
}
